export const VERTICAL_ALIGN = {
  start: 'start',
  center: 'center',
};
